import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { protectedRoutes } from 'constants/routes'

import GroupAddRoundedIcon from '@mui/icons-material/GroupAddRounded'
import ShareRoundedIcon from '@mui/icons-material/ShareRounded'
import { Container, Grid } from '@mui/material'
import { useAuthContext } from 'AuthProvider'
import { ActionButton, MessageInfo, PopUpButton, SearchBox } from 'components/commonparts'
import ShowLastUpdateDatetime from 'components/commonparts/ShowLastUpdateDatetime/ShowLastUpdateDatetime'
import { DataList } from 'components/parts/UserList'
import { useGridSearch } from 'hooks/useGridSearch';
import { useUser } from 'hooks/useUser'
import { initDataListStatus } from 'types/types'

import type { MstUserOutput } from 'api-client'
import type { DataListStatus } from 'types/types'

function UserList() {
  const { loginUserInfo } = useAuthContext()

  const { userSearch, fetchUserSearch, userSearchResult, userSearchIsLoading } = useUser()
  const gridSearch = useGridSearch({ autoShowOnCtrlF: true })

  const [listStatus, setListStatus] = useState<DataListStatus>({
    ...initDataListStatus(),
  })
  const navigate = useNavigate()

  const { search } = useLocation()
  const query = new URLSearchParams(search)
  // クエリパラメーターを取得
  const trQueryParam = {
    companyId: Number(query.get('company_id')),
  }

  // ソート順とページ番号の変更通知
  const onListStatusChange = (status: DataListStatus) => {
    fetchUserSearch({
      companyId: loginUserInfo?.tenantId === null ? trQueryParam.companyId : loginUserInfo?.companyId,
      limit: status.paginationModel.pageSize,
      pageNo: status.paginationModel.page + 1,
    })

    setListStatus({ ...listStatus, sortModel: status.sortModel, paginationModel: status.paginationModel })
  }

  useEffect(() => {
    fetchUserSearch({
      companyId: loginUserInfo?.tenantId === null ? trQueryParam.companyId : loginUserInfo?.companyId,
      limit: listStatus.paginationModel.pageSize,
      pageNo: 0,
    })
  }, [])

  return (
    <Container maxWidth="md">
      <Grid direction="row" container justifyContent="space-between">
        <Grid component="div" sx={{ mt: 1, mb: 1 }}>
          <ActionButton
            caption="ユーザーを追加"
            onClick={() =>
              navigate(
                `/${protectedRoutes.UserDetail.path}?company_id=${
                  trQueryParam.companyId ? trQueryParam.companyId : loginUserInfo?.companyId
                }`
              )
            }
            startIcon={<GroupAddRoundedIcon />}
          />
          <PopUpButton
            caption="ログインURLの共有"
            messeage="URLをコピーしました。"
            onClick={() =>
              global.navigator.clipboard.writeText(
                `${new URL(document.URL).origin}/login${
                  loginUserInfo?.tenantId ? `?tenantId=${loginUserInfo?.tenantId}` : ''
                }`
              )
            }
            startIcon={<ShareRoundedIcon />}
          />
        </Grid>
        <Grid component="div">
          <ShowLastUpdateDatetime<MstUserOutput>
            list={userSearch.list}
            lastUpdateDatetime={userSearch.lastUpdateDatetime}
          />
        </Grid>
      </Grid>
      <SearchBox
        gridRef={gridSearch.searchBoxProps.gridRef}
        findSearchValue={gridSearch.searchBoxProps.findSearchValue}
        setFindSearchValue={gridSearch.searchBoxProps.setFindSearchValue}
        activeMatchNum={gridSearch.searchBoxProps.activeMatchNum}
        onFindChanged={gridSearch.searchBoxProps.onFindChanged}
        isVisible={gridSearch.searchBoxProps.isVisible}
        onHide={gridSearch.searchBoxProps.onHide}
      />
      <DataList
        list={userSearch}
        isLoading={userSearchIsLoading}
        listStatus={listStatus}
        onListStatusChange={onListStatusChange}
        gridRef={gridSearch.gridRef}
        findSearchValue={gridSearch.gridSearchProps.findSearchValue}
        onFindChanged={gridSearch.gridSearchProps.onFindChanged}
        isSearchVisible={gridSearch.searchBoxProps.isVisible}
      />
      <Grid direction="row" container justifyContent="space-between">
        <Grid component="div">
          <MessageInfo result={userSearchResult} />
        </Grid>
      </Grid>
    </Container>
  )
}

export default UserList
